import React from "react";
import { Link, useParams } from "react-router-dom";

const Logo = (props) => {
  const {lang} = useParams();
  return (
    <Link to={`/${lang}/search`} style={{ width: "400px" }}>
      <div
        style={{
          width: "100%",
          height: "110px",
          backgroundImage: 'url("/images/dkv-logo-onflow.svg")',
          backgroundSize: "auto 100%",
          backgroundRepeat: "no-repeat",
        }}
      />
    </Link>
  );
};

export default Logo;
